import React, { memo } from "react";
import { Pagination as AntPagination, Select } from "antd";
import { useTranslation } from "react-i18next";
import { cn } from "src/util/cn";

export interface CustomPaginationProps {
  totalCount: number;
  pageSize: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  setPageSize?: (size: number) => void;
  showRowsPerPage?: boolean;
  classNames?: { container?: string; select?: string };
}

const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

const CustomPagination: React.FC<CustomPaginationProps> = ({
  totalCount,
  pageSize,
  currentPage,
  setCurrentPage,
  setPageSize,
  showRowsPerPage = true,
  classNames = {},
}) => {
  const { t } = useTranslation();

  return (
    <div className={cn("flex flex-wrap items-center justify-between gap-4", classNames.container)}>
      {showRowsPerPage && setPageSize && (
        <div className={cn("flex items-center gap-2", classNames.select)}>
          <span className="text-sm text-[var(--color-gray8)]">
            {t("pagination.rowsPerPage", t("rows_per_page"))}
          </span>
          <Select
            value={pageSize}
            onChange={setPageSize}
            options={PAGE_SIZE_OPTIONS.map((n) => ({ label: n, value: n }))}
            className="w-20"
          />
        </div>
      )}
      <AntPagination
        current={currentPage}
        pageSize={pageSize}
        total={totalCount}
        onChange={setCurrentPage}
        showSizeChanger={false}
        showTotal={(total) =>
          `${total} ${t("pagination.items", t("items", "items"))}`
        }
      />
    </div>
  );
};

export default memo(CustomPagination);
